export const ticketPrint = 'printTicketThisTime'
export const stickerPrint = 'printstickerThisTime'
export const stickerPopUp = 'showPopupForSticker'
export const CollectionCartageBreakup = 'collCartageUi'
export const ewayBill = 'ewayBillUi'
export const bookingDone = 'PopupBookingSuccess'
export const consignmentAddPopUp = 'consignmentAddPopUp'
export const consignmentDelPopUp = 'consignmentDelPopUp'
export const areYouSureForBooking = 'YouShouldConfirmThis'
export const pickupAddress = 'pickupAddress'
export const deliveryAddress = 'deliveryAddress'
export const searchPopup = 'searchPopup'
export const pricingInquiryPopup = 'pricingInquiryPopup'
export const branchInquiryPopup = 'branchInquiryPopup'
export const lrTrackingPopup = 'lrTrackingPopup'
export const otpPopup = 'otpPopup'
export const branchCreditDebitNote = 'branchCreditDebitNote'
export const acceptRechargeReject = 'acceptRechargeReject'

export const gstValidationPopup = 'ValidateGSTN'
export const cancelDispatchModel = 'CancelDispatchPopup'
export const dispatchConfirmationModel = 'dispatchConfirmationModel'
export const dispatchSuccessModel = 'dispatchSuccessModel'
export const tripSelectionPopup = 'SelectTripInVehicle'
export const dispatchPrintModel = 'dispatch Print'
export const lastDispatchPrintModel = 'last DispatchPrint'
export const printMemoInputModal = 'printMemoInputModal'
export const printMemoPopupModal = 'Dispatch Memo'
export const stickerCopyModal = 'StickerCopyModal'
export const getNearBranchModal = 'GetNearBranchModal'

export const imageSource = 'ImageSourceOptions'
export const AutoBrnchTransRecvModal = 'AutoBrnchTransRecvModal'

export const AutoDeliveryCreate = 'AutoDeliveryCreate'
export const AutoDeliveryEdit = 'AutoDeliveryEdit'
export const autoDeliveryConfModal = 'autoDeliveryConfModal'
export const PickupAndDropoffModal = 'PickupAndDropoffModal'
export const UpdatePickupAndDropoffModal = 'UpdatePickupAndDropoffModal'
export const pickupAndDropOffConfModal = 'pickupAndDropOffConfModal'

export const weightChrgModal = 'WeightChrgModal'
export const updateWeightChrgModal = 'updateWeightChrgModal'
export const weightChrgConfModal = 'weightChrgConfModal'

export const deliveryChrgModal = 'DeliveryChrgModal'
export const updateDeliveryChrgModal = 'updateDeliveryChrgModal'
export const deliveryChrgConfModal = 'deliveryChrgConfModal'

export const demurrageChrgModal = 'DemurrageChrgModal'
export const updateDemurrageChrgModal = 'updateDemurrageChrgModal'
export const demurrageChrgConfModal = 'demurrageChrgConfModal'

export const saveLuggageCityData = 'saveLuggageCityData'
export const bookingChrgModal = 'BookingChrgModal'
export const updateBookingChrgModal = 'updateBookingChrgModal'
export const bookingChrgConfModal = 'bookingChrgConfModal'

//Branch Master
export const createNewBranchMaster = 'createNewBranchMaster'
export const editBranchMaster = 'editBranchMaster'
export const BrnhTransferMCol = 'BrnhTransferMCol'
export const BrnhTransferRecCol = 'BrnhTransferRecCol'
export const AutoReceivePopupModal = 'AutoReceivePopupModal'
export const UpdateAutoReceivePopupModal = 'UpdateAutoReceivePopupModal'

export const LRWiseDetailsReport = 'LRWiseDetailsReport'
export const UpdateAutoBrnchTransRecvModal = 'UpdateAutoBrnchTransRecvModal'
export const manageColQuickView = 'manageColQuickView'
export const manageColQuickViewBranch = 'manageColQuickViewBranch'
export const DispatchMemoManageCol = 'DispatchMemoManageCol'
export const BrnhTransferMemoManageCol = 'BrnhTransferMemoManageCol'
export const DetailedPartyBookingmodal='DetailedPartyBookingmodal'
export const UpdatePickupAndDropoffModalkgkm = 'UpdatePickupAndDropoffModalkgkm'
export const ticketFormat = 'TicketFormat'
export const ticketFormatCreate = 'TicketFormatCreate'
export const expenseHead = 'ExpenseHead'
export const expenseSubHead = 'ExpenseSubHead'

export const updateCreateNewPartyModal = 'updateCreateNewPartyModal'
// export const mobileNoVerificationModal = 'mobileNoVerificationModal'
export const cargoRechargeRequestModal='cargoRechargeRequestModal'
export const companyLuggageSettingModel='companyLuggageSettingModel'
export const companyLuggageSettingEwayBillModel='companyLuggageSettingEwayBillModel'
